<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <!-- Footer Column -->
        <div class="col-lg-4 footer_col">
          <div class="footer_about">
            <!-- Logo -->
            <div class="logo_container">
              <div class="logo">
                <div>Renata Kość</div>
                <div>biuro podróży</div>
                <div class="logo_image"><img src="images/logo.png" alt="" /></div>
              </div>
            </div>
            <div class="footer_about_text">
              Kierując się dewizą, że każdą pracę należy wykonywać z ogromną starannością i zapałem
              nasi pracownicy od kilkunastu lat starają się sprostać oczekiwaniom naszych klientów.
              Oferują pełen zakres usług turystycznych i produktów z nimi związanych.
            </div>
            <div class="copyright">
              <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
              Copyright &copy; {{ currentYear }} All rights reserved | Created by
              <a href="https://kotech.io/">Kotech - IT Projects</a> <br />Using template made with
              <i class="fa fa-heart-o" aria-hidden="true"></i> by
              <a href="https://colorlib.com" target="_blank">Colorlib</a>
              <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
            </div>
          </div>
        </div>

        <!-- Footer Column -->
        <div class="col-lg-4 footer_col">
          <div class="footer_latest">
            <div class="footer_title">Najnowsze Wycieczki</div>
            <div class="footer_latest_content">
              <!-- Footer Latest Post -->
              <div v-for="trip in trips" :key="trip.id" class="footer_latest_item">
                <div class="footer_latest_image">
                  <MImage
                    :default-img="trip.thumbnail_photo"
                    :trip="trip"
                    alt="Marena Gorlice"
                    data-cy="footer-trip-img"
                  />
                </div>
                <div class="footer_latest_item_content">
                  <div class="footer_latest_item_title">
                    <router-link :to="{ name: 'trip', params: { id: trip.id } }">{{
                      trip.title
                    }}</router-link>
                  </div>
                  <div class="footer_latest_item_date">
                    {{ trip.start_date }} - {{ trip.end_date }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Column -->
        <div class="col-lg-4 footer_col">
          <div class="tags footer_tags">
            <div class="footer_title">Kontakt</div>
            <ul
              class="tags_content flex-row flex-wrap align-items-start justify-content-start footer_about_text contact"
            >
              <li>Biuro Podróży Marena</li>
              <li>38-300 Gorlice</li>
              <li>ul. Krakowska 2</li>
              <li>NIP: 7381009911</li>
              <li>tel: 601 083 770 / 18 354 07 21</li>
              <li>e-mail: marena.gorlice@gmail.com</li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <img src="@/assets/pfr.png" class="pfr" />
      </div>
    </div>
  </footer>
</template>

<script>
import cli from '@/http.js'
import MImage from '@/components/MImage.vue'

export default {
  name: 'Footer',
  components: {
    MImage,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      trips: [],
    }
  },
  mounted() {
    this.fetchTrips()
  },
  methods: {
    async fetchTrips() {
      const resp = await cli.get('/trips/?limit=2')
      this.trips = resp.data.results.slice(0, 2)
    },
  },
}
</script>

<style scoped>
.contact {
  padding-top: 0;
}
.pfr {
  max-width: 100%;
}
</style>
